import React from 'react';
import { cn } from '../../lib/utils';

export function HomeSectionHeader({
  title,
  subtitle,
  badge,
  light = false,
  titleAs = 'h2',
  className,
}: {
  title: string;
  subtitle?: string;
  badge?: string;
  light?: boolean;
  titleAs?: 'h1' | 'h2';
  className?: string;
}): React.JSX.Element {
  const titleClassName = cn(
    'font-serif text-4xl font-normal leading-[0.98] tracking-tight text-balance md:text-5xl xl:text-6xl',
    light ? 'text-[var(--ir-ivory)]' : 'text-[var(--ir-ink)]'
  );

  return (
    <div className={cn('mb-10 max-w-4xl md:mb-14', className)}>
      {badge ? (
        <span
          className={cn(
            'mb-6 inline-block rounded-full border px-4 py-1.5 text-xs font-bold uppercase tracking-[0.14em]',
            light
              ? 'border-[var(--ir-mint)]/35 text-[var(--ir-mint)]'
              : 'border-[var(--ir-terra)]/30 bg-[var(--ir-parchment)]/70 text-[var(--ir-terra-ink)]'
          )}
        >
          {badge}
        </span>
      ) : null}
      {titleAs === 'h1' ? (
        <h1 className={titleClassName}>{title}</h1>
      ) : (
        <h2 className={titleClassName}>{title}</h2>
      )}
      {subtitle ? (
        <p
          className={cn(
            'mt-6 max-w-2xl font-sans text-lg leading-relaxed md:text-xl',
            light ? 'text-white/70' : 'text-[var(--ir-muted)]'
          )}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
